import { Container, Typography } from "@mui/material";
import homeLogo from "../../images/assets/homeLogo.png";
import homeLineup from "../../images/assets/homeLineup.png";
import homeInfo from "../../images/assets/lineupfinal.png";
import videoWebm from "../../videos/mpf2025.webm";
import videoMp4 from "../../videos/mpf2025.mp4";

function Home() {
  return (
    <div className="home">
      <div className="home-tickets">
        <Container maxWidth="xl">
          <div className="modal-content">
            <div className="line-up-container-image">
              <img className="home-logo-image" src={homeLogo} alt="logo" />
              <img
                className="home-lineup-image"
                src={homeLineup}
                alt="lineup"
              />
              <img className="home-info-image" src={homeInfo} alt="info" />

              <div className="home-ticket-button">
                <Typography className="home-title" variant="h4">
                  Tickets sold out
                </Typography>
                <br />
                <Typography className="home-title" variant="h4">
                  JOIN OUR MAILING LIST BELOW LIST FOR ANY UPDATES.
                </Typography>
                <br />
                <br />
              </div>

              <video width="100%" autoPlay loop muted playsInline>
                <source src={videoWebm} type="video/webm" />

                <source src={videoMp4} type="video/mp4" />
              </video>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
}
export default Home;
